import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Pagination from '@cashew/pagination';

import { order } from '@cashew/types';
import cn from 'classnames';
import { Box, PageWithNavigation, Title, List, Button } from '../../components';
import ListItem from './ListItem';
import OrdersFilter from './OrderFilter';

const ns = 'customers';

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [list, setList] = useState<Array<order.OrderType> | undefined>(
    undefined
  );
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [isData, setIsData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  return (
    <div className={ns}>
      <Helmet>
        <title>{t('customers.title')}</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          Customers
          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" alt="filter" />
                Filters
              </div>
            </Button>
          </span>
        </Title>
        <div className={cn({ 'hide-filter': !showFilter })}>
          <OrdersFilter
            setLoading={setLoading}
            useSelector={useSelector}
            type="cashew"
            setRecords={setRecords}
            setList={setList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            history={history}
            dispatch={dispatch}
            isListEmpty={!isData}
            setIsData={setIsData}
            isData={isData}
            setPageNumber={setPageNumber}
            records={records}
          />
        </div>
        <Box withHeader>
          <div>
            <div className={`${ns}__headers`}>
              <p>Customer Name</p>
              <p>Email</p>
              <p>Mobile number</p>
              <p>National ID</p>
              <p>Status</p>
            </div>
            <List
              data={list}
              component={ListItem}
              context="customers"
              isLoading={loading}
              t={t}
              isOffline
            />
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </div>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
